import React from "react";

import "./composerDisplay.css";
import { getApiUrl } from "../../data/api/apiManager";
import ConfirmedIcon from "../../assets/icons/confirmedIcon";
import { useNavigate } from "react-router-dom";
import { ArtistResponseDTOMin } from "../../openapi-generated-client";

interface ComposerDisplayProps {
    artist: ArtistResponseDTOMin;
    confirmed: boolean;
}

export default function ComposerDisplay(props: ComposerDisplayProps) {

    var description = props.artist.shortBiography ? props.artist.shortBiography : "";
    if(description.length > 50) {
        description = description.substring(0, 50) + "...";
    }

    if(description) {
        return <div key={props.artist.id} className="composer-display extended" onClick={() => {
            if(props.artist.id == undefined) return;
            window.open("/artists/" + props.artist.id, "_self");
        }}>
            <img className="composer-image" src={getApiUrl("assets/by-hash/" + props.artist.profilePicture)} alt={props.artist.name} />
            <a>{props.artist.name}{props.confirmed ? <ConfirmedIcon/> : <></>}</a>
            <p className="quotation">{description}</p>
        </div>
    }

    return <div key={props.artist.id} className="composer-display" onClick={() => {
        if(!props.artist.id || props.artist.id <= 0) return;
        window.open("/artists/" + props.artist.id, "_self");
    }}>
        {props.artist.id ? <img className="composer-image" src={getApiUrl("assets/by-hash/" + props.artist.profilePicture)} alt={props.artist.name} /> : <></>}
        <a>{props.artist.name}{props.confirmed ? <ConfirmedIcon/> : <></>}</a>
    </div>


}